export const sz = {
  header: {
    logoPrintAlt: 'Süddeutsche Zeitung',
    logoAlt: 'SZ Plus',
  },
  config: {
    region: true,
    advertisingConsent: false,
    earliestStartDateOffsetForPrintInDays: 10,
    orderWithoutAddressCustomizable: true,
    dayPassPrefixes: ['DSZ1TAG'],
  },
  meta: {
    title:
      'Ihre Bestellung - Süddeutsche Zeitung und SZ Plus - sueddeutsche.de',
  },
  contact: {
    link: 'service/kontaktformular',
    phoneNumber: '089/2183-8080',
    myDataLink: 'https://abo.sueddeutsche.de/service/meine-daten',
  },
  start: {
    headline1: 'Ihre Bestellung',
    headline2: 'Ihre Daten',
  },
  modals: {
    browserBack: {
      copy: '<p>Mit der Bestellung eines digitalen Abonnements können Sie über den Button “Zur SZ-Startseite” direkt auf der SZ-Homepage lesen.</p><p>Möchten Sie Änderungen an Ihrer Bestellung oder Ihrem bestehenden Abonnement vornehmen, dann klicken Sie bitte auf “Zu Konto & Abo”.</p>',
      link1: {
        label: 'Zur SZ-Startseite',
        href: 'https://produkte.sueddeutsche.de/',
      },
      link2: {
        href: 'https://abo.sueddeutsche.de/service/meine-abos',
      },
    },
  },
  gpNr: {
    headlineWithGpNr: 'Ich habe bereits eine Kundennummer',
    headlineWithoutGpNr: 'Ich habe noch keine Kundennummer',
    gpNrInputHint:
      '10-stellig, beginnt mit 3. Sie finden die Kundennummer in der Bestellbestätigung',
    error: {
      gpNrNotValid: 'Keine gültigen Daten',
      formValidationMessage:
        'Bitte überprüfen Sie die gekennzeichneten Felder und füllen Sie die Pflichtfelder aus.',
      agb: 'Bitte Akzeptieren Sie die AGB',
      gpLocked:
        'Der Onlinezugriff auf Ihre Daten ist zu unserem Bedauern nicht möglich, bitte wenden Sie sich an unseren Kundenservice: Telefon 089/2183-8080. Sie erreichen uns von Montag bis Freitag von 07:00 Uhr bis 18:00 Uhr und samstags von 07:30 Uhr bis 12:30 Uhr oder Sie nutzen das <I>Kontaktformular</I>.  <BR />' +
        'Vielen Dank für Ihr Verständnis.',
      gpUsed:
        '<strong>Verknüpfung fehlgeschlagen.</strong><br />' +
        'Ihr Abo/Ihre Kundennummer ist bereits einem anderen Benutzernamen zugeordnet.<br />' +
        'Bitte verwenden Sie diesen bereits vergebenen Benutzernamen. Haben Sie diesen vergessen, dann folgen Sie bitte diesem Link: <a href="https://www.sueddeutsche.de/?show-my-account" target="_blank" rel="noopener noreferrer">Benutzername oder Passwort vergessen?</a>',
    },
  },
  payment: {
    headline2: 'Bitte wählen Sie eine Zahlmethode',
    messageError: 'Bitte prüfen Sie die eingegebenen Daten.',
  },
  verification: {
    headline1: 'Bestellung abschließen',
    agbAdditional:
      'Ich stimme ausdrücklich zu, dass vor Ablauf der Widerrufsfrist mit der Ausführung des Vertrages begonnen wird. Mir ist bekannt, dass mein Widerrufsrecht durch diese Zustimmung mit der Beginn der Ausführung erlischt.',
  },
  success: {
    backLinkSrc: 'https://produkte.sueddeutsche.de/',
    subscriptionStartUrl:
      'https://produkte.sueddeutsche.de/after-purchase-step-1/',
    contactSrc: '/service/kontaktformular',
    phone: '089 / 2183 - 8080',
    phoneSrc: 'tel:+498921838080',
    registrationPossible:
      '<b>Wichtig!</b> Scheinbar haben Sie in der Vergangenheit schon bei uns bestellt oder sind Kunde/Kundin. In Kürze erhalten Sie eine E-Mail, über die Sie Ihre Kundendaten anhand Ihrer Kundennummer zusammenführen können.',
    additionalCopy:
      '<p>Die digitale Welt der SZ bietet Ihnen vielfältige Inhalte. Unter <a href="https://produkte.sueddeutsche.de/willkommen/" target="_blank">sz.de/auf-einen-blick</a> können Sie sich einen ersten Überblick verschaffen.</p>',
    additionalCopyDigital:
      '<p>Sie möchten lieber direkt Ihren gewünschten Artikel lesen.<br>Dann klicken Sie <a href="${ARTICLE_LINK}">hier</a>.</p>',
    articleLinkFallback: 'https://www.sueddeutsche.de/',
  },
  orderExists: {
    info: 'Dieses Produkt wurde bereits für Sie aktiviert.<br /> Sie haben aktuell Zugriff auf alle SZ-Plus-Artikel.',
    buttonText: 'Zurück zur Startseite',
    buttonTextBackToArticle: 'SZ Plus Artikel lesen',
    link: 'https://produkte.sueddeutsche.de/',
  },
  followUpOffer: {
    infoText:
      '<p> Sie können mit Ihren aktuellen Zugangsdaten SZ Plus bereits nutzen.</p><p class="mb-0">Endet Ihr Angebot demnächst? Bestellen Sie hier Ihr Folgeangebot.</p>',
    homePageLink: 'https://produkte.sueddeutsche.de/',
  },
  error: {
    headline1: 'Es tut uns leid . . .',
    server: '. . . es gab ein Serverproblem.',
    startPageLink: 'https://produkte.sueddeutsche.de/',
    startPageLinkLabel: 'Zu weiteren Angeboten',
    supportId: 'Fehlercode',
  },
  productunavailable: {
    headline2: '. . . dieses Produkt ist nicht verfügbar.',
  },
  trialExpired: {
    headline1: 'Es tut uns leid . . .',
    headline2: '. . . dieses Produkt können Sie im Moment nicht bestellen.',
    textDigital:
      'Es ist uns wichtig, dass Sie die digitalen Produkte der Süddeutschen Zeitung kostenlos kennenlernen und ausprobieren. Sie hatten bereits die Möglichkeit, SZ Plus zu testen. Um weiterhin alle Texte lesen zu können, wählen Sie bitte eines der folgenden Angebote',
    textPrint:
      'Es ist uns wichtig, dass Sie die gedruckte Ausgabe der Süddeutschen Zeitung zu einem vergünstigten Preis kennenlernen und ausprobieren können. Sie hatten bereits die Möglichkeit, die Süddeutsche Zeitung zu testen. Um weiterhin bestens informiert zu bleiben, wählen Sie bitte eines der folgenden Angebote.',
    linkLabelDigital: 'SZ Plus Artikel lesen',
    linkSrcDigital: 'https://angebote.sueddeutsche.de/?offersId=offersMonthly',
    linkLabelPrint: 'Die Süddeutsche Zeitung lesen',
    linkSrcPrint: 'https://sz.de/weitereangebote',
  },
  legal: {
    imprintSrc: 'https://www.sueddeutsche.de/impressum',
    privacySrc: 'https://www.swmh-datenschutz.de/sz',
    wcagSrc: 'https://agb.swmh.de/bfsg_erklaerung_sz',
    wcagText: 'Infos zur Barrierefreiheit',
    copyright:
      'Copyright © Süddeutsche Zeitung Digitale Medien GmbH / Süddeutsche Zeitung GmbH',
    agbSrc: 'https://service.sueddeutsche.de/lesermarkt/service/agb.html',
    dataPrivacyLink: 'https://www.swmh-datenschutz.de/sz',
    revocationLink:
      'https://service.sueddeutsche.de/lesermarkt/service/faq-widerruf.html',
    agbSrcDigital:
      'https://service.sueddeutsche.de/lesermarkt/service/agb.html',
    agbSrcPrint: 'https://service.sueddeutsche.de/lesermarkt/service/agb.html',
    agbSrcMagazine:
      'https://service.sueddeutsche.de/lesermarkt/service/agb.html',
    cancellationSrc:
      'https://service.sueddeutsche.de/lesermarkt/service/faq-widerruf.html',
    partner:
      'Ihr Vertragspartner ist die Süddeutsche Zeitung GmbH, Hultschiner Str. 8, 81677 München. Geschäftsführer: Dr. Christian Wegner (Vors.), Johannes Hauner, Amtsgericht München HRB 73515. ',
    dataPrivacy:
      'Die Süddeutsche Zeitung GmbH verarbeitet Ihre Daten zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO), mit berechtigtem Interesse an einer Kundenbetreuung (Art. 6 Abs. 1 lit. f DSGVO) und für werbliche Zwecke mit Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). Wir können Ihnen Informationen über ähnliche Produkte und Leistungen per E-Mail zusenden. Ein Widerspruch ist jederzeit über <a href="mailto:werbewiderspruch@sz.de">werbewiderspruch@sz.de</a> möglich.',
    dataPrivacyAddition:
      'Infos zum Datenschutz unter <a href="https://www.swmh-datenschutz.de/sz" target="_blank" rel="noopener noreferrer">Datenschutzerklärung</a>.',
  },
  advertisingConsent: {
    disclaimer:
      'Ja, ich willige ein, dass mich die Süddeutsche Zeitung GmbH über ihre Medienangebote informieren darf (Widerruf jederzeit möglich):',
    privacy: 'sz.de/datenschutz',
    mail: 'Newsletter und Angebote per E-Mail erhalten',
    phone: 'Persönliche Beratung und Angebote per Telefon',
  },
  youngAdultSubscriptionForm: {
    headline: 'Das SZ Plus U{age} Abo',
    copy: 'Für dieses vergünstigte U{age} Angebot ist eine Altersprüfung erforderlich. Wir benötigen dazu das Geburtsdatum und die Prüfnummern des Personalausweises. Bitte nachfolgend eintragen:',
    errorTooOld:
      'Es tut uns leid, aber dieses Angebot steht nur Personen bis zum vollendeten {age-1}. Lebensjahr zur Verfügung. Wir danken Ihnen für das Interesse und haben auf unserer <a href="https://produkte.sueddeutsche.de" target="_blank" rel="noopener">Produktseite</a> weitere attraktive Angebote für Sie.',
    errorTooYoung:
      'Es tut uns leid, aber dieses Angebot steht nur für Personen ab 18 Jahren zur Verfügung. Wir danken für das Interesse an der Süddeutschen Zeitung. Für unsere jungen Leser empfehlen wir <a href="https://www.jetzt.de" target="_blank" rel="noopener">https://www.jetzt.de</a>',
    textInterest:
      'Wir verwenden das Geburtsdatum für Glückwünsche aufgrund unseres <a href="https://www.swmh-datenschutz.de/sz_bi_geburtsdatum" target="_blank" rel="noopener">berechtigten Interesses</a>. Die Geburtstagsmail kann direkt in der ersten Mail oder unter <a href="mailto:widerruf@sz.de">widerruf@sz.de</a> abbestellt werden. Weitere Infos zum Datenschutz unter <a href="https://sz.de/datenschutz" target="_blank" rel="noopener">sz.de/datenschutz</a>',
  },
};
